var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail-view',{attrs:{"endpoint":_vm.endpoint + 'zones',"hiddenValues":_vm.hiddenValues,"name":"Zone","parentRoute":"zones","permissions":"zones","values":_vm.values}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2e97ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"objectAssign":"Object.assign","transforms":{"stripWith":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ZoneEdit.vue
// module id = null
// module chunks = 